import client from './api-client';

export const getConfiguracionForm85 = async(query) => {
    try {
        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form85: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getCuotas = async(query) => {
    try {
        
        const response = await client.getSelect(`consulta/detalle/declaracion-pago?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosDecPago: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetHistorialCuota = async(query) => {
    try {
        const response = await client.getSelect(`consulta/detalle/declaracion-pago?h=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch(error) {
        throw error;
    }
}
export const serviceGetDocumento = async(query) => {
    try {
        const response = await client.getDoc(`get-file?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}
